import { h } from "preact";
import { determineManualOrder } from "../utils/ManualOrderUtils";
const DateSelector = ({
  selectedDateId,
  dates,
  selectDate,
  name = "Select Date"
}) => {
  const isManualOrder = determineManualOrder();
  const buttonStyle = {
    margin: "0px 10px 20px 0"
  };
  if (dates.length === 1) {
    return "";
  }
  const sortedDates = dates.sort(function(a, b) {
    a = new Date(a.startDate);
    b = new Date(b.startDate);
    return a > b ? 1 : a < b ? -1 : 0;
  });

  const dateChange = e => {
    const id = e.target.value;
    let date;
    dates.forEach(d => {
      if (d._id === id) {
        date = d;
      }
    });
    selectDate(id, date.display, date.startDate);
  };
  return (
    <div style={{ margin: "0 0 40px 0" }}>
      <label for="date-selector" style={{ marginBottom: 4, fontWeight: 600 }}>
        {name}
      </label>
      <select
        id="date-selector"
        class="form-select"
        onChange={dateChange}
        value={selectedDateId}
      >
        {sortedDates.map(date => {
          if (date.valid || isManualOrder) {
            return (
              <option value={date._id} disabled={!date.valid && !isManualOrder}>
                {date.display.combined}
                {date.soldOut && <span> (Sold Out)</span>}
              </option>
            );
          }
        })}
      </select>
    </div>
  );
};
export default DateSelector;



// WEBPACK FOOTER //
// ./components/DateSelector.js